module.exports = __webpack_public_path__ + "d205268a2182fe20abbdeddd9c4ab8a3.svg";